import { HttpVerb } from '../Enums/http-verb';
import { RestApiRequestFormatType } from '../Enums/rest-api-request-format-type';
import { RestApiAuthenticationConfiguration } from './rest-api-authentication-configuration';
import { RestApiRequestHeaderConfiguration } from './rest-api-request-header-configuration';

export class RestApiRequestConfiguration {
    public httpVerb: HttpVerb;
    public url: string;
    public headers: RestApiRequestHeaderConfiguration[] = [];
    public requestContent: string = null;
    public authentication: RestApiAuthenticationConfiguration = new RestApiAuthenticationConfiguration();
    public requestFormat: RestApiRequestFormatType;

    /**
     * Retourne une copie d'une instance de RestApiRequestConfiguration
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: RestApiRequestConfiguration) {
        if (!!other) {
            const instance = new RestApiRequestConfiguration();

            instance.httpVerb = other.httpVerb;
            instance.url = other.url;
            instance.headers = RestApiRequestHeaderConfiguration.cloneArray(other.headers);
            instance.requestContent = other.requestContent;
            instance.authentication = RestApiAuthenticationConfiguration.clone(other.authentication);
            instance.requestFormat = other.requestFormat;

            return instance;
        } else {
            return null;
        }
    }

    /**
     * Retourne une copie d'un tableau d'instances de RestApiRequestConfiguration
     * @param other : Tableau source.
     * @returns : Copie du tableau.
     */
    public static cloneArray(others: RestApiRequestConfiguration[]) {
        if (!!others) {
            let responses: RestApiRequestConfiguration[] = [];

            others.forEach((x) => {
                const response = RestApiRequestConfiguration.clone(x);
                responses.push(response);
            });

            return responses;
        } else {
            return [];
        }
    }
}
